import { Loader } from '../Loader'
import * as S from './styled'

export const FallBack = () => (
  <S.FallBackWrapper>
    <Loader show={true} transparent={true} />
  </S.FallBackWrapper>
)
